import { Tabs as MantineTabs } from "@mantine/core";
import React                   from "react";

import useStyles from "./styles.js";
const RooterTabs = allProps => {
	const { classNames, defaultValue, children, ...props } = allProps;
	const { classes }                                      = useStyles ( {}, { name: "rooterTabs" } );

	return (
		<MantineTabs
			classNames   = { {
				root     : classes.tabsRoot,
				tab      : classes.tab,
				tabLabel : classes.tabLabel,
				tabsList : classes.tabsList,
				panel    : classes.panel
			} }
			defaultValue = { defaultValue }
			{ ...props }
		>
			{children}
		</MantineTabs>
	);
};

RooterTabs.List  = MantineTabs.List;
RooterTabs.Tab   = MantineTabs.Tab;
RooterTabs.Panel = MantineTabs.Panel;
export default RooterTabs;
